var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.529,
    height: 47.324,
    viewBox: "0 0 48.529 47.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-round-no-photography",
    "data-name": "Icon material-round-no-photography",
    d: "M24.5,16.783,16.464,8.75,18.6,6.405A4.711,4.711,0,0,1,22.036,4.9H31.88a4.622,4.622,0,0,1,3.413,1.509L38.172,9.54h7.36a4.657,4.657,0,0,1,4.643,4.643V42.044a2.315,2.315,0,0,1-.046.371L38.288,30.574a10.96,10.96,0,0,0,.279-2.461A11.613,11.613,0,0,0,26.958,16.5a10.96,10.96,0,0,0-2.461.279ZM45.021,50.425l-3.738-3.738H8.385a4.657,4.657,0,0,1-4.643-4.643V14.183A4.672,4.672,0,0,1,5.32,10.724l-3-3A2.315,2.315,0,0,1,5.6,4.455L48.272,47.128a2.312,2.312,0,0,1,0,3.274A2.264,2.264,0,0,1,45.021,50.425ZM32.739,38.143l-3.483-3.483a7.6,7.6,0,0,1-2.3.418,6.956,6.956,0,0,1-6.965-6.965,6.72,6.72,0,0,1,.441-2.275l-3.483-3.483a11,11,0,0,0-1.6,5.758A11.613,11.613,0,0,0,26.958,39.722a11.353,11.353,0,0,0,5.781-1.579Z",
    transform: "translate(-1.647 -3.777)",
    fill: "#abafc6",
    opacity: 0.672
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageIcon);
export default __webpack_public_path__ + "static/media/noImageIcon.6fa5f72830782855d7b93e8fed4f22a8.svg";
export { ForwardRef as ReactComponent };